/**
 * Единая типизированная точка чтения окружения.
 * Никакой другой модуль не читает import.meta.env напрямую.
 */
export interface AppConfig {
  /** Базовый путь к API. Всегда относительный: dev – Vite proxy, prod – nginx. */
  apiBase: string;
  /** URL сервиса аутентификации (SSO). */
  loginUrl: string;
  /** Имя окружения для страницы проверки работы. */
  appEnv: string;
  /** Версия сборки. */
  version: string;
}

export const config: AppConfig = {
  apiBase: '/api',
  loginUrl: import.meta.env.VITE_LOGIN_URL ?? 'https://local.auth.org',
  appEnv: import.meta.env.VITE_APP_ENV ?? 'local',
  version: __APP_VERSION__,
};
